/**
 * Titan — reposition the Stoq collection button below the price module.
 *
 * Stoq (Restock Rocket) injects a `.restock-rocket-button-collection` button
 * into each <product-card> at runtime. By default base.css pins that button as
 * an absolute, hover-reveal overlay at the bottom of the card. On normal
 * collection / homepage product cards we instead want it to sit in normal flow
 * directly below the price module (<product-price>).
 *
 * This script only MOVES the button within its own <product-card> (so it stays
 * a descendant of any [data-discord-link] wrapper and Stoq's own click handling
 * / context tracking keep working). It adds a marker class so the scoped CSS in
 * titan-stoq-collection-position.css can undo the absolute positioning without
 * affecting the button anywhere else.
 *
 * Locked cards (`.titan-locked-info` present) are skipped entirely — their
 * button is handled separately by titan-locked-stoq-move.js.
 *
 * Stoq injects asynchronously at an unknown time, so we run on DOM ready, watch
 * for late injection with a MutationObserver, and re-run on theme-editor section
 * loads. Relocation is idempotent.
 */
(function () {
  'use strict';

  var BUTTON_SELECTOR = '.restock-rocket-button-collection';
  var POSITIONED_CLASS = 'titan-stoq-collection-positioned';

  function repositionButtons() {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];

      var card = btn.closest('product-card');
      if (!card) continue;

      // Locked cards manage this button separately — never touch them.
      if (card.querySelector('.titan-locked-info') || btn.closest('.titan-locked-stoq-wrapper')) {
        continue;
      }

      // The price module is the <product-price> block; fall back to the price
      // container / price element if the custom element is ever absent.
      var priceEl =
        card.querySelector('product-price') ||
        card.querySelector('[ref="priceContainer"]') ||
        card.querySelector('.price');
      if (!priceEl) continue;

      // Already in the right place — nothing to do (keeps this idempotent).
      if (priceEl.nextElementSibling !== btn) {
        priceEl.insertAdjacentElement('afterend', btn);
      }

      if (!btn.classList.contains(POSITIONED_CLASS)) {
        btn.classList.add(POSITIONED_CLASS);
      }
    }
  }

  function init() {
    repositionButtons();

    // Catch Stoq's asynchronous injection (and any later re-render that moves
    // the button back out). repositionButtons() is a cheap no-op once the
    // button is already in place.
    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function (mutations) {
        var shouldRun = false;
        for (var i = 0; i < mutations.length && !shouldRun; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (
              node.classList.contains('restock-rocket-button-collection') ||
              node.querySelector('.restock-rocket-button-collection')
            ) {
              shouldRun = true;
              break;
            }
          }
        }
        if (shouldRun) repositionButtons();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    // Fallback ticks in case the observer is unavailable or misses early frames.
    setTimeout(repositionButtons, 800);
    setTimeout(repositionButtons, 1800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-run when a section is re-rendered.
  document.addEventListener('shopify:section:load', repositionButtons);
})();
